export { default as Cake } from './Cake'
